import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

const DisabilityClaimDetails = (props) => {
  const classes = useStyle();

  const [dateOfDisability, setDateOfDisabity] = useState('')
  const [hospitalAttended, setHospitalAttended] = useState('');
  const [natureOfIllnesOrDisability, setNatureOfIllnessOrDisability] = useState('');
  const [patientNumber, setPatientNumber] = useState('');



  React.useEffect(() => {
    props.setAdditionalState("monthly_installment_amount", props.eventData.additional_details.monthly_installment_amount)
    props.setAdditionalState("beneficiary_national_id", props.eventData.additional_details.beneficiary_national_id)
    props.setAdditionalState("product_code", props.eventData.product_code)
    props.setAdditionalState("policy_start_date", props.eventData.start_date)
  }, [ props.member.date_of_birth]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "dateOfDamage") {
      handleSubmit(value)
    }

  }


  const handleSubmit = (value) => {

    const tempClaimInitiation = props.claimInitiationPayload;
    tempClaimInitiation["additional_details"] = {
      "device_number": props.eventData.additional_details.device_number
    };
    props.setClaimInitiationPayload(tempClaimInitiation);
  }



  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Personal Details</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="name"
              style={{ width: "100%" }}
              label="first_name"
              name='first_name'
              value={props.member.first_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="middle_name"
              style={{ width: "100%" }}
              label="middle_name"
              name='middle_name'
              value={props.member.middle_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="last_name"
              style={{ width: "100%" }}
              label="last_name"
              name='last_name'
              value={props.member.last_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="relationship"
              style={{ width: "100%" }}
              label="relationship"
              name='relationship'
              value={props.member.relationship}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="gender"
              style={{ width: "100%" }}
              label="gender"
              name='gender'
              value={props.member.gender}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_birth"
              style={{ width: "100%" }}
              label="date_of_birth"
              name='date_of_birth'
              value={props.member.date_of_birth}
              variant="outlined"
            />
          </Grid>


        </Grid>

        <hr />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.headingclaim}>
              <h4>Claim Information For Permanent Disability </h4>
            </div>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={6}>
            <div className={classes.headingclaim}>
              <h4>Intrest Rate </h4>
            </div>
          </Grid> */}
        </Grid>

        <Grid container spacing={2} className={classes.selectpolicyWrapper}>



          <Grid item xs={12} sm={6} md={6}>
            <TextValidator
              id="dateOfDisability"
              label="Date Of Disability"
              name='dateOfDisability'
              value={dateOfDisability}
              onChange={(e) => {
                setDateOfDisabity(e.target.value)
                props.setAdditionalState("date_of_disability", e.target.value)
              }}
              style={{ width: "100%" }}
              fullWidth
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <TextValidator
              id="hospitalAttended"
              label="Hospital Attended"
              name='hospitalAttended'
              value={hospitalAttended}
              onChange={(e) => {
                setHospitalAttended(e.target.value)
                props.setAdditionalState("hospital_attended", e.target.value)
              }}
              style={{ width: "100%" }}
              fullWidth
              type='text'
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <TextValidator
              id="natureOfIllnesOrDisability"
              label="Nature Of Illness Or Disability"
              name='natureOfIllnesOrDisability'
              value={natureOfIllnesOrDisability}
              onChange={(e) => {
                setNatureOfIllnessOrDisability(e.target.value)
                props.setAdditionalState("nature_of_illnes_or_disability", e.target.value)
              }}
              style={{ width: "100%" }}
              fullWidth
              type='text'
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <TextValidator
              id="patientNumber"
              label="Patient Number"
              name='patientNumber'
              value={patientNumber}
              onChange={(e) => {
                setPatientNumber(e.target.value)
                props.setAdditionalState("patient_number", e.target.value)
              }}
              style={{ width: "100%" }}
              fullWidth
              type='text'
              variant="outlined"
            />
          </Grid>


        </Grid>

      </ValidatorForm>
    </>
  )
}

export default DisabilityClaimDetails

